import { useRegisterCommandsWithRegistry } from '@atlassian/jira-command-palette/src/controllers/use-register-commands/index.tsx';
import type { COMMAND_PALETTE_REGISTRY_ID } from '../../common/constants/registry';

export const useRegisterCommands = useRegisterCommandsWithRegistry<COMMAND_PALETTE_REGISTRY_ID>;
